module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Agregar",
      "btn-function": ""
    },
    on: {
      "function-click": _vm.openModal
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "include-delete-single": true,
      "selectable": false,
      "switch-value": 'flagActive'
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-change-state": _vm.changeState,
      "on-delete-event": _vm.deleteRow,
      "go-to-edit-page": _vm.openModal
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.color))]), _vm._v(" "), _c('td', [(props.row.urlImage) ? _c('img', {
          staticClass: "table-img",
          attrs: {
            "src": props.row.urlImage,
            "alt": props.row.name,
            "height": "38",
            "width": "40"
          }
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": function($event) {
        _vm.loadData(_vm.params.page)
      }
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "50%"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Agregar Categoría")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-1": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  }), _vm._v(" "), (_vm.$v.model.name && _vm.$v.model.name.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEl nombre es requerido\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Código")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.code),
      callback: function($$v) {
        _vm.model.code = $$v
      },
      expression: "model.code"
    }
  }), _vm._v(" "), (_vm.$v.model.code && _vm.$v.model.code.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEl código es requerido\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Color")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "color"
    },
    model: {
      value: (_vm.model.color),
      callback: function($$v) {
        _vm.model.color = $$v
      },
      expression: "model.color"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "px-1": "",
      "mt-3": ""
    }
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "label": "Mostrar en POS",
      "hiden-details": ""
    },
    model: {
      value: (_vm.model.flagMain),
      callback: function($$v) {
        _vm.model.flagMain = $$v
      },
      expression: "model.flagMain"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pl-1": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Imagen")]), _vm._v(" "), _c('file-upload-container', {
    attrs: {
      "label-for": ("image-" + (_vm.rows.length + 1)),
      "image-url": _vm.model.urlImage,
      "min-resolution": 10,
      "max-resolution": 3000
    },
    on: {
      "upload": _vm.onUploadImage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action",
    attrs: {
      "type": "button",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.createCategory($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167d04e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/categories/List.vue
// module id = 1591
// module chunks = 31